module.exports = __webpack_public_path__ + "img/card2.22f8a800.png";